import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardModuleConstants } from './dashboard-module.constants';
import { AppCommonModule } from '../common/app-common.module';
import { SharedModule } from '../shared/shared.module';
import {
  CarouselModule, CollapseModule, TabsModule, BsDropdownModule, ModalModule
} from 'ngx-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    AppCommonModule,
    SharedModule,
    CarouselModule.forRoot(),
    CollapseModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot()
    //BsDropdownModule.forC(),
  ],
  declarations: DashboardModuleConstants.MODULE_COMPONENTS,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [DashboardModuleConstants.MODULE_COMPONENTS]
})
export class DashboardModule { }
